import React from "react";

interface Props {
  show: boolean;
  onClose: () => void;
  feature: string;
}

export default function ComingSoonModal({ show, onClose, feature }: Props) {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content shadow">
          <div className="modal-header bg-warning">
            <h5 className="modal-title">🚧 Coming Soon</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p>
              The <strong>{feature}</strong> section is under development and will be available soon.
            </p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
